module.exports = __webpack_public_path__ + "static/media/18b.730e0851.jpg";